import { Component, OnInit, Input } from '@angular/core';
import {emtrConstant} from '../../constants/emtrConstants';

@Component({
    selector: 'tr-rule-name-type',
    templateUrl: './rule-name-type.component.html',
    styleUrls: ['./rule-name-type.component.scss']
})
export class RuleNameTypeComponent {
@Input() ruleName: string;
@Input() ruleType: string;
@Input() showRuleName = true;
@Input() isSuperRestriction = false;
getConstant = emtrConstant;

getRuleTypeLabel(): string {
  if (this.ruleType === 'RESTRICT_LST_ENG') {
    return this.isSuperRestriction
      ? this.getConstant.rulesConstant.ruleGlobalConst.superRestriction
      : this.getConstant.rulesConstant.ruleGlobalConst.restriction;
  }
  if (this.ruleType === 'Override') {
    return this.getConstant.rulesConstant.ruleGlobalConst.override;
  }
  return this.getConstant.rulesConstant.ruleGlobalConst.watchList;
}
}
